<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    persistent
  >
    <v-card data-cy="modal_reposta">
      <v-card-title
        class="title pt-5 pb-0 px-4"
        primary-title
        data-cy="modal_reposta_titulo"
      >
        {{ titulo }}
      </v-card-title>

      <div>
        <v-card-text
          class="pt-3"
          data-cy="modal_reposta_texto"
        >
          <p>
            <slot name="texto" />
          </p>
        </v-card-text>
      </div>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          :href="urlBtnFechar"
          data-cy="fechar_sucesso_reembolso"
        >
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'ModalResposta',

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    titulo: {
      type: String,
      required: true,
    },
    urlBtnFechar: {
      type: String,
      default: '/minhas-compras',
    },
  },
};
</script>
